const roles = [
  { role: 1, description: "quest" },
  { role: 3, description: "user" },
  { role: 2, description: "admin" },
];

const roleArr = {
  notAuth: [1],
  isAuth: [1, 2, 3],
  isAdmin: [2],
};

/* role pages */
const rolePageArr = {
  HomePage: [1, 2, 3],
  ErrorPage: [1, 2, 3],
  Error404: [1, 2, 3],
  TosPage: [1, 2, 3],
  PrivacyPage: [1, 2, 3],
  CookiePolicyPage: [1, 2, 3],
  ContactPage: [1, 2, 3],
  UsersHome: [1, 2, 3],
  UsersSignIn: [1, 2, 3],
  UsersUpdate: [1, 2, 3],
  UsersDetail: [1, 2, 3],
  UsersList: [1, 2, 3],
  UsersSearch: [1, 2, 3],
  UsersLogin: [1, 2, 3],
  UsersForgotPassword: [1, 2, 3],
  SchemaHome: [1, 2, 3],
  SchemaCreate: [1, 2, 3],
  SchemaUpdate: [1, 2, 3],
  SchemaDetail: [1, 2, 3],
  SchemaList: [1, 2, 3],
  SchemaSearch: [1, 2, 3],
  ContactsHome: [1, 2, 3],
  ContactsCreate: [1, 2, 3], 
  ContactsUpdate: [1, 2, 3], 
  ContactsDetail: [1, 2, 3], 
  ContactsList: [1, 2, 3], 
  ContactsSearch: [1, 2, 3], 
  TasksHome: [1, 2, 3],
  TasksCreate: [1, 2, 3],
  TasksUpdate: [1, 2, 3],
  TasksDetail: [1, 2, 3],
  TasksList: [1, 2, 3],
  TasksSearch: [1, 2, 3],
  KanbanBoard: [1, 2, 3],
  CalendarView: [1, 2, 3],
  MermaidHome: [1, 2, 3],
  MermaidCreate: [1, 2, 3],
  MermaidUpdate: [1, 2, 3],
  MermaidDetail: [1, 2, 3],
  MermaidList: [1, 2, 3],
  MermaidSearch: [1, 2, 3],
  // Admin pages
  AdminHome: [1, 2, 3],
  AdminSettings: [1, 2, 3],
  AdminSiteSettings: [1, 2, 3],
  AdminUsers: [1, 2, 3],
  AdminAnalytics: [1, 2, 3],
  AdminLogs: [1, 2, 3],
  AdminSchema: [1, 2, 3],
  AdminSchemaCreate: [1, 2, 3],
  AdminSchemaUpdate: [1, 2, 3],
  AdminSchemaDetail: [1, 2, 3],
  AdminContacts: [1, 2, 3],
  DockerInfo: [3],
  FilesHome: [2, 3],
  FilesCreate: [1, 2, 3], 
  FilesUpdate: [2, 3], 
  FilesDetail: [2, 3], 
  FilesList: [2, 3], 
  FilesSearch: [2, 3], 
  SliderHome: [2, 3],
  SliderCreate: [1, 2, 3], 
  SliderUpdate: [2, 3], 
  SliderDetail: [2, 3], 
  SliderList: [2, 3], 
  SliderSearch: [2, 3], 
  UnitsHome: [2, 3],
  UnitsCreate: [1, 2, 3], 
  UnitsUpdate: [2, 3], 
  UnitsDetail: [1,2, 3], 
  UnitsList: [1,2, 3], 
  UnitsSearch: [2, 3], 
  OptionsHome: [2, 3],
  OptionsCreate: [1, 2, 3], 
  OptionsUpdate: [2, 3], 
  OptionsDetail: [2, 3], 
  OptionsList: [2, 3], 
  OptionsSearch: [2, 3], 
  SinifHome: [2, 3],
  SinifCreate: [1, 2, 3], 
  SinifUpdate: [2, 3], 
  SinifDetail: [2, 3], 
  SinifList: [2, 3], 
  SinifSearch: [2, 3], 
  DersHome: [2, 3],
  DersCreate: [1, 2, 3], 
  DersUpdate: [2, 3], 
  DersDetail: [2, 3], 
  DersList: [2, 3], 
  DersSearch: [2, 3], 
  SchoolsHome: [2, 3],
  SchoolsCreate: [1, 2, 3], 
  SchoolsUpdate: [2, 3], 
  SchoolsDetail: [2, 3], 
  SchoolsList: [2, 3], 
  SchoolsSearch: [2, 3], 
  StudentsHome: [2, 3],
  StudentsCreate: [1, 2, 3],
  StudentsCreateExcel: [1, 2, 3],
  StudentsUpdate: [2, 3], 
  StudentsDetail: [2, 3], 
  StudentsList: [2, 3], 
  StudentsSearch: [2, 3], 
  SubjectsHome: [2, 3],
  SubjectsCreate: [1, 2, 3], 
  SubjectsUpdate: [2, 3], 
  SubjectsDetail: [2, 3], 
  SubjectsList: [2, 3], 
  SubjectsSearch: [2, 3], 
  GeminiDemo: [1, 2, 3],
  SimulationHome: [],
  SimulationCreate: [], 
  SimulationUpdate: [], 
  SimulationDetail: [], 
  SimulationList: [], 
  SimulationSearch: [], 
  ExamHome: [],
  ExamCreate: [], 
  ExamUpdate: [], 
  ExamDetail: [], 
  ExamList: [], 
  ExamSearch: [], 
  empty: [],
};

export default { ...roleArr, ...rolePageArr };
export { roles };
